import {AfterViewInit, Component, OnInit, ViewEncapsulation} from '@angular/core';
import {Router} from '@angular/router';
import {isNullOrUndefined} from 'util';
import {IndexPluginsService} from '../../../services/index/index-plugins.service';
import {UserInfoService} from '../../../services/user-info/user-info.service';

/**
 * @module [Module]index-operation
 *
 * @class [Component]IndexComponent 主页面
 * @todo 用户信息和权限控制未实现，需待userService完成
 */
@Component({
  selector: 'bw-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class IndexComponent implements OnInit, AfterViewInit {
  constructor (private userInfo: UserInfoService,
               private router: Router,
               private indexPlugService: IndexPluginsService) {
  }

  ngOnInit () {
    // const pathArr = this.location.path().toString().split('/');
    // const roles = ['admin', 'nurse', 'user', 'demo'];
    if (isNullOrUndefined(localStorage.getItem('userInfo'))) {
      // if (roles.indexOf(pathArr[1]) > -1) {
      //   this.router.navigate([pathArr[1] + '/login']);
      //   // location.href = pathArr[1] + '/login';
      // } else {
        this.router.navigate(['admin/login']);
        // location.href = 'nurse/login';
      // }
        swal('您没有权限访问', '请重新登录', 'warning');
      // this.sweetAlertService.showALert({
      //   title: '您没有权限访问',
      //   text: '请重新登录',
      //   showCancelButton: false,
      //   confirmButtonText: '去登录',
      //   cancelButtonText: '取消',
      // }, (confirm: any) => {
      //   if (confirm) {
      //     this.sweetAlertService.hide();
      //     if (roles.indexOf(pathArr[1]) > -1) {
      //       location.href = pathArr[1] + '/login';
      //     } else {
      //       location.href = 'nurse/login';
      //     }
      //   } else {
      //     this.sweetAlertService.hide();
      //   }
      // });
    }
  }

  ngAfterViewInit (): void {
    this.indexPlugService.requirePlugins();
  }
}



// WEBPACK FOOTER //
// D:/taile-operate/BLACK-WIDOW/ng-src/app/module/index-operation/index/index.component.ts